import { c as _c } from "react/compiler-runtime";
/* eslint-disable @next/next/no-img-element */
import { useRouter } from "next/navigation";
import Image from "next/image";
import ctaImg from "public/assets/heroIllustrations/ctaImg.webp";
import Link from "next/link";
import { cx } from "lib/cx";
import { ArrowLongRightIcon } from "@heroicons/react/24/outline";
import GetResumeScoreIcon from "public/icons/getResumeScore.svg";
export const Cta = () => {
  const $ = _c(26);
  const router = useRouter();
  let t0;
  if ($[0] !== router) {
    t0 = () => {
      router.push("/resume-builder?open-import=true");
    };
    $[0] = router;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleResumeImport = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cx("steps-shadow absolute left-1/2 top-0 z-10 -translate-x-1/2 overflow-hidden rounded-[20px] bg-white px-3 md:rounded-[44px] md:px-6", "w-[288px] md:w-[473px] lg:w-[630px] xl:w-[788px] 2xl:w-[946px]", "w-[133px] md:h-[169px] lg:h-[185px] xl:h-[231px] 2xl:h-[277px]");
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <img src="/assets/heroIllustrations/ctaBgSVG.svg" alt="" className="absolute -left-[7rem] -top-[7rem] hidden md:-left-[6rem] md:-top-[6rem] md:block lg:-left-[5rem] lg:-top-[5rem] xl:-left-14 xl:-top-14" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cx("font-montserrat font-light text-[#52A1FF]", "text-[12.43px] md:text-[20.4px] lg:text-[27.2px] xl:text-[34px] 2xl:text-[40.8px]", "leading-[13.89px] md:leading-[20.8px] lg:leading-[30.4px] xl:leading-[38px] 2xl:leading-[45.6px]");
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <h2 className={t3}>Ready to build your <br /><span className="font-normal">professional resume ?</span></h2>;
    t5 = cx("hidden gap-2 pt-4 md:flex", "text-[9.9px] lg:text-[13.2px] xl:text-[16.5px] 2xl:text-[19.8px]");
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Link href="/resume-builder"><button className="btn-gradient rounded-[40px] px-2 py-1 font-poppins lg:px-4 xl:px-8 xl:py-2">Generate Now <ArrowLongRightIcon className="h-6 w-6" /></button></Link>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <GetResumeScoreIcon className="h-6 w-6" />;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== handleResumeImport) {
    t8 = <div className="w-[65%] md:pt-8 xl:pt-10">{t4}<div className={t5}>{t6}<button className="flex items-center gap-2 rounded-[40px] px-2 py-1 font-poppins shadow-lg lg:px-4 xl:px-8 xl:py-2" onClick={handleResumeImport}>Get Resume Score {t7}</button></div></div>;
    $[9] = handleResumeImport;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = cx("relative", "w-[80px] md:w-[131px] lg:w-[174px] xl:w-[218px] 2xl:w-[262px]", "h-[75px] md:h-[124px] lg:h-[165px] xl:h-[206px] 2xl:h-[247px]");
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="flex h-full items-center"><div className={t9}><Image src={ctaImg} alt="cta" fill={true} style={{
          objectFit: "contain"
        }} /></div></div>;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t8) {
    t11 = <div className="relative flex h-full w-full items-center justify-between pt-2 md:pt-0">{t2}{t8}{t10}</div>;
    $[13] = t8;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = cx("my-2 flex justify-between md:hidden", "text-[10px]");
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Link href="/resume-builder" className="btn-gradient items-center rounded-[40px] px-4 py-2 font-poppins">Generate Now <ArrowLongRightIcon className="h-4 w-4" /></Link>;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <GetResumeScoreIcon className="h-6 w-6" />;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== handleResumeImport) {
    t15 = <div className={t12}>{t13}<button className="flex items-center gap-2 rounded-[40px] px-2 py-2 font-poppins shadow-lg" onClick={handleResumeImport}>Get Resume Score {t14}</button></div>;
    $[18] = handleResumeImport;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== t11 || $[21] !== t15) {
    t16 = <div className={t1}>{t11}{t15}</div>;
    $[20] = t11;
    $[21] = t15;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className={cx("absolute bottom-0 w-full bg-[#87C5FF]", "h-[87px] md:h-[63px] lg:h-[84px] xl:h-[105px] 2xl:h-[126px]")} />;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  let t18;
  if ($[24] !== t16) {
    t18 = <section className="relative h-[140px] md:h-[200px] lg:h-[235px] xl:h-[280px] 2xl:h-[305px]">{t16}{t17}</section>;
    $[24] = t16;
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  return t18;
};